import React, { useState, useContext, useEffect, useRef, RefObject } from 'react';
import classnames from 'classnames';
import { Icon } from '@/components';
import { ProductContext } from '.';
import { CacheImageData, SockBottomImage } from './new-sock';
import styles from './style.less';
import { i18n, priceFormat } from '@/utils';

interface OptionPluginProps {
  /** 展开变换状态 */
  expandChange: boolean;
  /** 颜色缓存 */
  backgroundCache: RefObject<CacheImageData>;
  /** 关闭回调 */
  onClose: () => void;
}

const OptionExpand: React.FC<OptionPluginProps> = ({ expandChange, backgroundCache, onClose }) => {

  // 袜子数据
  const { sockData, allPrice, title, shop, productSelected, setProductSelected } = useContext(ProductContext);
  /** 底图已选择名字 */
  const colorNameSelected = useRef<string>('');
  /** 底图选择 */
  const [ colorSelected, setColorSelected ] = useState<string | undefined>(productSelected.color);
  /** 底图已选择名字 */
  // const [ colorNameSelected, setColorNameSelected ] = useState<string>('');
  /** 尺寸选择 */
  const [ sizeSelected, setSizeSelected ] = useState<string | undefined>(productSelected.size);
  /** 底色数组 */
  let colors: SockBottomImage[] = [];
  sockData.forEach(item => {
    if (item.id == sizeSelected) {
      colors = item.bottomImages;
    }
  });

  /** 改变袜子选项 */
  const handleChange = () => {
    setProductSelected({
      color: colorSelected,
      size: sizeSelected,
    });
    onClose();
  }

  /** 取消更改 */
  const handleCancle = () => {
    onClose();
  }

  useEffect(() => {
    // 拿到初始选择的颜色名称
    colorNameSelected.current = colors.find(item => item.id === colorSelected)?.name ?? '';
  }, [ colorSelected ]);

  useEffect(() => {
    setColorSelected(productSelected.color);
    setSizeSelected(productSelected.size);
  }, [ expandChange ]);

  useEffect(() => {
    // 如果尺寸变了就拿对应 name 所指的颜色
    // 如果切换尺寸后没有对应 name 的颜色，则默认选中第一个
    const color = colors.find(item => item.name === colorNameSelected.current)?.id ?? colors[0].id;
    setColorSelected(color);
  }, [ sizeSelected ]);

  return (
    <div className={styles.optionExpand}>
      <div className={styles.title}>{title}</div>
      <div className={styles.price}>
        {/* <span className={styles.current}>{`${shop.currencySymbol}${price.toFixed(2)}`}</span> */}
        <span className={styles.current}>{priceFormat(shop.currencySymbol, allPrice.price.toFixed(2))}</span>
        {/* <span className={styles.origin}>{`${shop.currencySymbol}${originPrice.toFixed(2)}`}</span> */}
        <span className={styles.origin}>{priceFormat(shop.currencySymbol, allPrice.originPrice.toFixed(2))}</span>
      </div>
      <div className={classnames(styles.option, styles.optionColor)}>
        <div className={styles.optionTitle}>{`${i18n.format('modules.new.sock.color')}:`}</div>
        <div className={styles.colorOptions}>
          {colors.map((item, index) => {
            const imageCache = backgroundCache.current![sizeSelected as string][item.id];
            const backgroundImage = imageCache.variantImage || imageCache.image;
            const isImage = backgroundImage.includes('http') || backgroundImage.includes('base64');
            return (
              <div key={index} className={styles.optionLayout}>
                <div
                  className={classnames(styles.bottomImage, {
                    [styles.bottomImageSelected]: colorSelected === item.id,
                  })}
                  onClick={() => setColorSelected(item.id)}
                  style={{
                    backgroundImage: isImage && `url(${backgroundImage})`,
                    backgroundColor: !isImage && backgroundImage,
                  }}
                >
                  {(colorSelected === item.id) &&
                    <div className={styles.selectedIcon}>
                      <Icon type="tick-circle" color="#ff533a"  />
                    </div>
                  }
                </div>
              </div>
            );
          })}
        </div>
      </div>
      <div className={styles.option}>
        <div className={styles.optionTitle}>{`${i18n.format('modules.new.sock.size')}:`}</div>
        <div className={styles.sizeOptions}>
          {sockData.map((item) => (
            <div
              key={item.id}
              onClick={() => setSizeSelected(item.id)}
              className={classnames(styles.size, {
                [styles.sizeSelected]: sizeSelected === item.id,
              })}
            >
              <Icon
                type="tick-circle"
                color="#ff533a"
                className={styles.selectedIcon}
              />
              <span>{item.size}</span>
            </div>
          ))}
        </div>
      </div>
      <div className={styles.button}>
        <div className={styles.cancleButton} onClick={handleCancle}>
          {i18n.format('modules.global.cancel')}
        </div>
        <div className={styles.changeButton} onClick={handleChange}>
          {i18n.format('modules.global.change')}
        </div>
      </div>
    </div>
  )
}

export default OptionExpand;
